import type { Theme } from '@/contexts/ThemeContext';

type StatusLike = {
  color: string;
  settings?: Record<string, unknown> | null;
};

function getSetting(status: StatusLike, key: string): string | undefined {
  if (!status.settings || typeof status.settings !== 'object') return undefined;
  const value = (status.settings as Record<string, unknown>)[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * Zwraca kolor statusu aktualny dla motywu. W light mode — jeśli status ma
 * ustawiony `settings.lightColor`, używa go zamiast `color`. W dark mode
 * zawsze wraca do `color`.
 *
 * User konfiguruje alternatywny kolor dla light mode w edytorze statusu
 * (StatusManagementPage), bo niektóre mocne kolory są nieczytelne na białym.
 */
export function statusColor(status: StatusLike, theme: Theme): string {
  if (theme === 'light') {
    const light = getSetting(status, 'lightColor');
    if (light) return light;
  }
  return status.color;
}

/**
 * Zwraca kolor tekstu statusu aktualny dla motywu. W light mode prefer
 * `customTextColorLight` jeśli ustawione, potem fallback na `customTextColor`,
 * finalnie na sam kolor statusu.
 */
export function statusTextColor(status: StatusLike, theme: Theme): string {
  if (theme === 'light') {
    const lightText = getSetting(status, 'customTextColorLight');
    if (lightText) return lightText;
  }
  const text = getSetting(status, 'customTextColor');
  if (text) return text;
  return statusColor(status, theme);
}
